/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import * as Types from '@r-client/data/graphql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type IGetUserQueryVariables = Types.Exact<{ [key: string]: never }>;

export type IGetUserQuery = {
  __typename?: 'Query';
  user?:
    | {
        __typename?: 'User';
        id: string;
        authId?: string | null | undefined;
        requiresMultiFactorAuthentication?: boolean | null | undefined;
        hasAllowedOktaDomain: boolean;
        forceMultiFactorAuth?: boolean | null | undefined;
        slug: string;
        email?: string | null | undefined;
        confirmedAt?: string | null | undefined;
        firstName?: string | null | undefined;
        lastName?: string | null | undefined;
        fullLegalName?: string | null | undefined;
        avatarUrl?: string | null | undefined;
        verified?: boolean | null | undefined;
        founder: boolean;
        unreadMessagesCount: number;
        unreadNotificationsCount: number;
        lastIosAppSignInAt?: string | null | undefined;
        signInCount: number;
        isAdmin: boolean;
        backupCodesData?:
          | Array<{
              __typename?: 'MultiFactorAuthenticationBackupCode';
              id: string;
            }>
          | null
          | undefined;
        editableOfferings: Array<{
          __typename?: 'Offering';
          id: string;
          slug: string;
          companyName: string;
          logoUrl?: string | null | undefined;
          logoUrl2x?: string | null | undefined;
        }>;
        secretsData?:
          | {
              __typename?: 'MultiFactorAuthenticationSecret';
              authUri: string;
              secretKey: string;
            }
          | null
          | undefined;
        investorProfile?:
          | {
              __typename?: 'InvestorProfile';
              id: string;
              xSelfAccredited?: boolean | null | undefined;
              xRemainingInvestmentLimitCents?: number | null | undefined;
              hasActiveRepublicSubscription: boolean;
              inxIntegrationAccount?:
                | {
                    __typename?: 'InxIntegrationAccount';
                    id: string;
                    redirectUrl: string;
                    state: Types.IInxIntegrationAccountStateEnum;
                    createdAt: string;
                    inxUserId: string;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
        issuerApplications: {
          __typename?: 'IssuerApplicationConnection';
          nodes: Array<{ __typename?: 'IssuerApplication'; id: string }>;
        };
        issuerProfiles: Array<{
          __typename?: 'IssuerProfile';
          id: string;
          companyName?: string | null | undefined;
          onboardingCompleteness: number;
          offerings: Array<{
            __typename?: 'Offering';
            id: string;
            logoUrl?: string | null | undefined;
            hasPublished: boolean;
            indexInAllOfferings: number;
            regulation: Types.IOfferingRegulationEnum;
            slug: string;
          }>;
        }>;
        teaserPages?:
          | {
              __typename?: 'TeaserPageConnection';
              nodes: Array<{
                __typename?: 'TeaserPage';
                id: string;
                slug: string;
                companyName: string;
                backgroundImageUrl?: string | null | undefined;
                logoImageUrl?: string | null | undefined;
                summary: string;
                socialLinksUrls: Array<string>;
                tag?:
                  | { __typename?: 'TagsTag'; slug: string }
                  | null
                  | undefined;
              }>;
            }
          | null
          | undefined;
        accreditedAccess?:
          | {
              __typename?: 'AccreditedAccess';
              state?:
                | Types.IAccreditedAccreditedAccessStateEnum
                | null
                | undefined;
            }
          | null
          | undefined;
        followsOfferings?:
          | Array<{
              __typename?: 'Offering';
              following: boolean;
              tags?:
                | Array<{
                    __typename?: 'TagsTag';
                    following?: boolean | null | undefined;
                  }>
                | null
                | undefined;
            }>
          | null
          | undefined;
        capabilities?:
          | Array<{
              __typename?: 'Capability';
              id: string;
              domain?: Types.ICapabilityDomainEnum | null | undefined;
              level?: Types.ICapabilityLevelEnum | null | undefined;
            }>
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type IUserEmailQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;

export type IUserEmailQuery = {
  __typename?: 'Query';
  user?:
    | {
        __typename?: 'User';
        id: string;
        email?: string | null | undefined;
        unconfirmedEmail?: string | null | undefined;
      }
    | null
    | undefined;
};

export const GetUserDocument = gql`
  query getUser {
    user {
      id
      authId
      requiresMultiFactorAuthentication
      backupCodesData {
        id
      }
      hasAllowedOktaDomain
      forceMultiFactorAuth
      slug
      email
      confirmedAt
      firstName
      lastName
      fullLegalName
      avatarUrl(resize: { width: 110, height: 110, type: fill })
      verified
      founder
      unreadMessagesCount
      unreadNotificationsCount
      lastIosAppSignInAt
      signInCount
      editableOfferings {
        id
        slug
        companyName
        logoUrl(resize: { width: 35, height: 35, type: fit })
        logoUrl2x: logoUrl(resize: { width: 70, height: 70, type: fit })
      }
      secretsData {
        authUri
        secretKey
      }
      investorProfile {
        id
        xSelfAccredited
        xRemainingInvestmentLimitCents
        hasActiveRepublicSubscription
        inxIntegrationAccount {
          id
          redirectUrl
          state
          createdAt
          inxUserId
        }
      }
      issuerApplications {
        nodes {
          id
        }
      }
      issuerProfiles {
        id
        companyName
        onboardingCompleteness
        offerings {
          id
          logoUrl
          hasPublished
          indexInAllOfferings
          regulation
          slug
        }
      }
      teaserPages(first: 1) {
        nodes {
          id
          slug
          companyName
          backgroundImageUrl
          logoImageUrl
          summary
          socialLinksUrls
          tag {
            slug
          }
        }
      }
      accreditedAccess {
        state
      }
      followsOfferings {
        following
        tags {
          following
        }
      }
      isAdmin
      capabilities {
        id
        domain
        level
      }
    }
  }
`;
export type GetUserQueryResult = Apollo.QueryResult<
  IGetUserQuery,
  IGetUserQueryVariables
>;
export const UserEmailDocument = gql`
  query UserEmail($slug: String!) {
    user(slug: $slug) {
      id
      email
      unconfirmedEmail
    }
  }
`;
export type UserEmailQueryResult = Apollo.QueryResult<
  IUserEmailQuery,
  IUserEmailQueryVariables
>;
